<template>
  <div id="questionsAndResponsesContainer">
    <router-link :to="{name: 'admin'}" class="back-link">&larr; Back to all forms</router-link>
    <div class="componenet-nav">
      <div class="component-select-container">
        <div
          @click="selectedView = 'questions'"
          class="component-selector"
          :class="{selected: selectedView === 'questions'}"
        >QUESTIONS</div>
        <hr v-if="selectedView === 'questions'" class="questions-select-underline" />
      </div>
      <div class="component-select-container">
        <div
          @click="selectedView = 'responses'"
          class="component-selector"
          :class="{selected: selectedView === 'responses'}"
        >RESPONSES</div>
        <hr v-if="selectedView === 'responses'" class="responses-select-underline" />
      </div>
    </div>
    <div class="form-name">{{formName}}</div>
    <Questions v-if="selectedView === 'questions'" :formName="formName" :questions="questions" />
    <Responses
      v-if="selectedView === 'responses'"
      :formName="formName"
      :questions="questions"
      :teachers="teachers"
      :numTeachers="numTeachers"
    />
  </div>
</template>

<script>
// On page load, if the form parameter is undefined, get the form id from the path.
// get questions and responses to the form from the dbn
import axios from "axios";
import Responses from "../components/notecatcher/admins/Responses.vue";
import Questions from "../components/notecatcher/admins/Questions.vue";
import store from "@/store/index";
import { debug } from "util";

const apiBase = API_APP_PATH + "/v1";

export default {
  data() {
    return {
      formId: this.$route.params.formid,
      formName: "",
      selectedView: "questions",
      questions: {},
      teachers: {},
      numTeachers: 0,
      periodMap: {
        EOY: "End of Year",
        MOY: "Middle of Year",
        BOY: "Beginning of Year"
      }
    };
  },
  methods: {
    schoolYear(form) {
      return `${form.FiscalYear - 1} - ${form.FiscalYear}`;
    },
    response(question) {
      return {
        CommentID: question.CommentID,
        EmployeeId: question.EmployeeId,
        LastName: question.LastName,
        FirstName: question.FirstName,
        Comment: question.Comment,
        QuestionID: question.QuestionID
      };
    },
    getQuestionsAndResponses: async function() {
      const DBN = store.state.admin.schools
        ? store.state.admin.schools[0].SchoolDBN
        : store.state.dbn;
      const responsesByFormAndDbn = await axios.get(
        `${apiBase}/data/school/goalSetting/form/${this.$route.params.formid}/dbn/${DBN}`
      );
      const firstForm = responsesByFormAndDbn.data[0];
      this.formName = `${this.schoolYear(firstForm)} | ${
        this.periodMap[firstForm.Period]
      }`;
      return responsesByFormAndDbn.data.reduce(
        (questionsAndTeachers, question) => {
          if (!questionsAndTeachers.questions[question.QuestionID.toString()]) {
            questionsAndTeachers.questions[question.QuestionID.toString()] = {
              ...question,
              responses: []
            };
          }
          if (!questionsAndTeachers.teachers[question.EmployeeId.toString()]) {
            questionsAndTeachers.teachers[question.EmployeeId.toString()] = {
              ...question,
              responses: []
            };
            this.numTeachers++;
          }
          if (question.Comment) {
            questionsAndTeachers.teachers[
              question.EmployeeId.toString()
            ].responses.push(this.response(question));
            questionsAndTeachers.questions[
              question.QuestionID.toString()
            ].responses.push(this.response(question));
          }
          return questionsAndTeachers;
        },
        { questions: {}, teachers: {} }
      );
      return;
    }
  },
  components: { Questions, Responses },
  created() {
    const componentContext = this;
    componentContext
      .getQuestionsAndResponses()
      .then(res => {
        componentContext.questions = res.questions;
        componentContext.teachers = res.teachers;
      })
      .catch(e => {
        throw new Error(e);
      });
  }
};
</script>

<style scoped>
.back-link {
  margin-top: 1em;
  padding-top: 1em;
  font-family: Arial, Helvetica, sans-serif;
}
.form-name {
  height: 2.25em;
  font-family: Arial;
  font-size: 1.5em;
  color: #000000;
  margin: 1em 0em 0em 0.5em;
}

.componenet-nav {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  border-bottom: 2px solid grey;
  height: 4em;
  margin-top: 1em;
}
.component-select-container {
  position: relative;
  height: 100%;
}
.component-selector:hover {
  cursor: pointer;
}
.component-selector {
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: Arial;
  font-size: 1.5em;
  font-weight: bold;
  color: #9b9b9b;
}
.selected {
  color: #2c557d;
}
.questions-select-underline,
.responses-select-underline {
  position: absolute;
  width: 100%;
  border: 3px solid #2c557d;
  top: 85%;
  z-index: 10;
  opacity: 1;
}
</style>